export const downloadFromBlob = (
  data: BlobPart,
  fileName?: string,
  headers?: Record<string, any>, // axios headers와 호환
) => {
  // Content-Disposition에서 파일명 추출 시도
  let finalFileName = fileName || 'download';

  if (headers) {
    const contentDisposition = headers['content-disposition'] || headers['Content-Disposition'];
    if (contentDisposition) {
      // 간단한 filename 추출 (filename="name" 또는 filename=name 형식)
      const match = contentDisposition.match(/filename[*]?=["']?([^"';,]+)/i);
      if (match) {
        try {
          finalFileName = decodeURIComponent(match[1].replace(/^UTF-8''/, ''));
        } catch (e) {
          finalFileName = match[1];
        }
      }
    }
  }

  const url = URL.createObjectURL(
    new Blob([data as unknown as BlobPart], {
      type: 'application/json',
    }),
  );
  const link = document.createElement('a');
  link.href = url;
  link.download = finalFileName;
  link.click();
  URL.revokeObjectURL(url);
};
